import { tokens } from '@domain-group/design-tokens';
var colors = tokens.colors;
export default (() => ({
  colour: {
    inputBorder: colors.neutral.heavy.default,
    inputBackground: colors.neutral.surface.default,
    inputText: colors.neutral.heavy.default,
    inputHoverBorder: colors.neutral.heavy.hover,
    inputFocusBorder: colors.neutral.trim.pressed,
    inputFocusBackground: colors.neutral.surface.default,
    inputFocusText: colors.neutral.heavy.default,
    inputDisabledBorder: colors.neutral.trim.default,
    inputDisabledBackground: colors.neutral.subdued.default,
    inputDisabledText: colors.neutral.medium.default,
    inputErrorBorder: colors.critical.trim.default,
    inputErrorBackground: colors.neutral.surface.default,
    inputErrorText: colors.critical.heavy.default,
    inputErrorFocusBorder: colors.critical.trim.pressed,
    inputErrorFocusBackground: colors.neutral.surface.default,
    inputErrorFocusText: colors.critical.heavy.default,
    inputPlaceholderText: colors.neutral.medium.default
  }
}));